<div class="row">
  <div class="form-group pb0">
    <span class="icon"></span>
    <div class="card-veiculo-proprio">
      <div class="card-veiculo-proprio_card">
        <div>
          <span class="card-veiculo-proprio_title">{{ title }}</span>

          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="onClickRemove()">
            <span aria-hidden="true">&times;</span>
          </button>
          <button
            type="button"
            class="close card-veiculo-proprio_btn-edit"
            aria-label="Edit"
            [disabled]="hasAnyEdit"
            (click)="onClickEdit()">
            <span class="glyphicon glyphicon-pencil"></span>
          </button>
        </div>
        <div
          *ngIf="!hasPlaca"
          class="card-veiculo-proprio_descricao">
          <span>{{ descricao }}</span>
        </div>
        <div
          *ngIf="hasPlaca"
          class="card-veiculo-proprio_info">
          <dl class="card-veiculo-proprio_info_label">
            <dt>Placa</dt>
            <dd>{{ veiculo.veiculoPlaca }}</dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</div>
